import React, { useEffect, useState, FC, useMemo } from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';
//import { FormItem } from './useInterfaces/FormInterfeses';
import * as types from "../gql/graphql";

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';

import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AddIcon from '@mui/icons-material/Add';

import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { DataGrid, GridColDef, GridActionsCellItem, GridRowId } from '@mui/x-data-grid';

import { styled, lighten, darken } from '@mui/system';

import { useForm, Controller } from 'react-hook-form';

//import "primereact/resources/themes/md-light-indigo/theme.css";

import AddEventDialog from './AddEventDialog'
import MDBox from './MDBox/MDBoxRoot';
import MDButton from './MDButton/MDButtonRoot';
import MDInput from './MDInput/MDInputRoot';
import MDTypography from './MDTypography/MDTypographyRoot';
import { useScreenSize } from "../hooks/ScreenSizeContext";
import { SchoolTime } from '../utils/SchoolTime';
import { useQueryAll } from '../apolloClient';
import { Alert, CircularProgress } from '@mui/material';

const GroupHeader = styled('div')(({ theme }) => ({
    position: 'sticky',
    top: '-8px',
    padding: '4px 10px',
    color: theme.palette.primary.main,
    textTransform: "capitalize",
    backgroundColor:
        theme.palette.mode === 'light'
            ? lighten(theme.palette.primary.light, 0.85)
            : darken(theme.palette.primary.main, 0.8),
}));

const GroupItems = styled('ul')(({ theme }) => ({
    padding: 0,
    color: theme.palette.primary.main,
    //color:"black"
}));


interface EditStudentDialogProps {
    StudentID: number;
}

const getPurchasesQuery = gql(`query GetPurchases($id:BigInt) {
    fs_purchasesCollection(filter: {Student: {eq: $id}}) {
        edges {
          node {
            nodeId
            id
            Date
            fs_students { id }
            fs_classes { name }
            fs_packages { name }
            fs_registrationsCollection { 
              edges {  node {
                id 
                fs_classes {  name id }
                AvailableNum
                fs_signupCollection {
                  edges {
                    node {
                      status
                      id
                      fs_events {
                        date
                      }
                    }
                  }
                }
            }}
            }
          }
        }
      }
  }`);

const getClassesForPurchase = gql(`
  query GetClassesForPurchase($after: Cursor) {
    fs_classesCollection(
        filter: {active:{eq: true}}, 
        orderBy: [{category: AscNullsLast}, {listorder:AscNullsLast}],
        after: $after 
        ) {
        pageInfo { endCursor startCursor hasNextPage } 
        edges {
          node {
            nodeId
            id
            name
          }
        }
      }
  }
 `);

const getPackagesForPurchase = gql(`
  query GetPackagesForPurchase($after: Cursor) {
    fs_packagesCollection(
        filter: {active:{eq: true}}, 
        orderBy: [{category: AscNullsLast}, {listorder:AscNullsLast}],
        after: $after ) {
        pageInfo { endCursor startCursor hasNextPage } 
        edges {
          node {
            nodeId
            id
            name
          }
        }
      }
  }
 `);

const addPurchaseQuery = gql(`
 mutation AddPurchase($st:BigInt!, $so:Int!, $pa: BigInt!, $cl:BigInt!, $ad: Int, $nm: Int) {
     add_purchase(p_student: $st, p_source: $so, p_package:$pa, p_class:$cl, p_additional:$ad, p_number:$nm)
 }
`);

const deleteSignUpQuery = gql(`
mutation DeleteSignup($id:BigInt!) {
    delete_signup(p_id: $id)
}
`);

const deleteRegistrationQuery = gql(`
mutation DeleteRegistration($id:BigInt!) {
    delete_registration(p_id: $id)
}
`);

const saveRegistrationCountQuery = gql(`
mutation saveRegistrationCount($c:Int, $id: BigInt) {
  updatefs_registrationsCollection(set: {AvailableNum: $c}, filter: {id:{eq:$id}}) {
    affectedCount
  }
}
`)


// Build clean three level tree of purchase->registration->signup
interface Signup {
    id: number;
    class: string;
    status: string;
    eventDate: string;
}

interface Registration {
    id: number;
    class: string;
    classId: number;
    availableNum: number;
    signups: Signup[];
    signedNum: number;
    purchase: Purchase;
    date: string;
    prodName: string;
}

interface Purchase {
    id: number;
    date: string;
    studentId: number;
    class?: string;
    package?: string;
    name: string;
    registrations: Registration[];
}

interface RegistrationsListType {
    allSignups: Signup[];
    regs: Registration[];
}

const getStatus = (s) => { // scheduled - 0, attended - 1, waitlist - 2
    return (s == 0) && "Scheduled"
        || (s == 1) && "Attended"
        || (s == 2) && "Wait List";
};

interface PurchasesProps {
    StudentID: number; // Define the prop "number" as a number type
}

const Purchases: FC<PurchasesProps> = (props) => {

    const { data, error, loading, refetch } = useQuery(getPurchasesQuery, { variables: { id: props.StudentID }, fetchPolicy: 'network-only' });

    const { data: Cdata } = useQueryAll<types.Fs_ClassesEdge>({ query: getClassesForPurchase });
    const { data: Pdata } = useQueryAll<types.Fs_PackagesEdge>({ query: getPackagesForPurchase });

    const [purchasesList, setPurchasesList] = useState<RegistrationsListType>(null);
    //onst [signupList, setSignupList] = useState(null);
    const [isPurchaseModalOpen, setIsPurchaseModalOpen] = useState(false);
    //    const [isSignUpOpen, setIsSignUpOpen] = useState(false);

    const [registrationRow, setRegistrationRow] = useState(null);
    const [isAddSignUpModalOpen, setIsAddSignUpModalOpen] = useState(false);
    const [isEditRegistrationModalOpen, setIsEditRegistrationModalOpen] = useState(false);
    const isSmallScreen = useScreenSize();

    const { register: purchaseRegister, handleSubmit: purchaseHandleSubmit, reset: purchaseReset, control: purchaseControl, formState: { errors: purchaseErrors } } = useForm({
        defaultValues: { number: 1, product: {} }
    });


    // Prepare list of classes and packages for new purchases
    const products = useMemo(() => {
        const classesForPurchase = Cdata?.map(edge => ({
            value: edge.node.id,
            label: edge.node.name,
            group: "class"
        })) || [];

        const packagesForPurchase = Pdata?.map(edge => ({
            value: edge.node.id,
            label: edge.node.name,
            group: "package"
        })) || [];

        return packagesForPurchase.concat(classesForPurchase);
    }, [Cdata, Pdata]);

    function convertGraphQLData(data: types.Fs_PurchasesConnection): RegistrationsListType {
        const convertedData = {
            regs: [],
            allSignups: []
        };

        data.edges.forEach(purchase => {
            const purchaseNode = purchase.node;
            const purchaseObject = {
                id: purchaseNode.id,
                date: purchaseNode.Date,
                studentId: purchaseNode.fs_students.id,
                class: purchaseNode.fs_classes?.name,
                package: purchaseNode.fs_packages?.name,
                name: purchaseNode.fs_classes?.name || purchaseNode.fs_packages?.name,
                registrations: []
            };

            purchaseNode.fs_registrationsCollection.edges.forEach(registration => {
                const registrationNode = registration.node;
                const registrationObject = {
                    id: registrationNode.id,
                    class: registrationNode.fs_classes?.name,
                    classId: registrationNode.fs_classes?.id,
                    availableNum: registrationNode.AvailableNum,
                    purchase: purchaseObject,
                    date: (SchoolTime.fromISO(purchaseObject.date))?.toDateTime().toFormat("D"),
                    prodName: purchaseObject.name,
                    signups: [],
                    signedNum: 0
                };
                convertedData.regs.push(registrationObject);

                var signup_num = 0;
                registrationNode.fs_signupCollection.edges.forEach(signup => {
                    const date = SchoolTime.fromISO(signup.node.fs_events?.date);
                    const signupObject = {
                        status: signup.node.status,
                        eventDate: date?.toDateTime().toFormat("f"),
                        id: signup.node.id,
                        class: registrationObject.class
                    };
                    if (signup.node.status == 0) signup_num++;

                    registrationObject.signups.push(signupObject);
                    convertedData.allSignups.push(signupObject);
                });

                registrationObject.signedNum = signup_num;
                purchaseObject.registrations.push(registrationObject);
            });
        });

        return convertedData;
    }

    useEffect(() => {
        if (data) {
            const conv = convertGraphQLData(data.fs_purchasesCollection);
            setPurchasesList(conv);
            //setSignupList(conv.allSignups);
        }
    }, [data]);

    // ======================================== Registration table definitions ===================================
    const [deleteRegistrationMutation, { loading: deleteRegistrationLoading, error: deleteRegistrationError }] = useMutation(deleteRegistrationQuery, {
        refetchQueries: [
            'GetPurchases' // Query name
        ],
    });

    const [isConfirmRegistrationDeletionOpen, setIsConfirmRegistrationDeletionOpen] = useState<String>('0');

    const handleRegistrationDeleteConfirmation = () => {
        deleteRegistrationMutation({ variables: { id: isConfirmRegistrationDeletionOpen } });
        setIsConfirmRegistrationDeletionOpen('0');
    }

    // ================================= Signups table definition ===================================

    const [deleteSignUpMutation, { loading: deleteSignUpLoading, error: deleteSignUpError }] = useMutation(deleteSignUpQuery, {
        refetchQueries: [
            'GetPurchases' // Query name
        ],
    });

    const handleSignUpDeleteClick = (id) => {
        // Function takes care of WL update
        deleteSignUpMutation({ variables: { id: id } });
        if (deleteSignUpError) console.log(deleteSignUpError);
    };


    // ============================== Registrations table hadlers ==================================
    const [addPurchaseMutation, { loading: addPurchaseLoading, error: addPurchaseError }] = useMutation(addPurchaseQuery, {
        refetchQueries: [
            'GetPurchases' // Query name
        ],
    });

    const handleRegistrationDeleteClick = (reg) => {
        if (reg.signups.length > 0) {
            // Show confirmation dialog
            setIsConfirmRegistrationDeletionOpen(reg.id);
        }
        else {
            // Delete immediately
            deleteRegistrationMutation({ variables: { id: reg.id } });
            if (deleteRegistrationError) console.log(deleteRegistrationError);
        }
    };

    const handleAddSignUpClick = (registration: any) => {
        setRegistrationRow(registration);
        setIsAddSignUpModalOpen(true);
    };

    // =============================== Editing registration number handlers =====================================
    const handleEditRegistrationsClick = (reg: any) => {
        setRegistrationRow(reg);
        setIsEditRegistrationModalOpen(true);
    };

    const [saveRegistrationCountMutation, { error: saveRegistrationCountError }] = useMutation(saveRegistrationCountQuery, {
        refetchQueries: [
            'GetPurchases' // Query name
        ],
    });

    const handleSaveRegCountValue = (reg: any, updated: number) => {
        if (updated !== undefined && reg && updated != reg.availableNum) {
            saveRegistrationCountMutation({ variables: { id: reg.id, c: updated } });
            if (saveRegistrationCountError) console.log(saveRegistrationCountError);
        }
        setIsEditRegistrationModalOpen(false);
    }

    ////////////////////////////////////////////////////////////////////////////////////

    if (loading) return <CircularProgress />;
    if (error) return <Alert severity="error">Failed to load purchases</Alert>;

    // Add new purchase and registration                 
    const onPurchaseFormSubmit = (data) => {

        if (data.product.group == "package") {
            addPurchaseMutation({ variables: { st: props.StudentID, so: 2 /*admin*/, pa: data.product.value, cl: 0, ad: 0, nm: data.number } });
            if (addPurchaseError) console.log(addPurchaseError);
        }
        else {
            addPurchaseMutation({ variables: { st: props.StudentID, so: 2 /*admin*/, pa: 0, cl: data.product.value, ad: 0, nm: data.number } });
            if (addPurchaseError) console.log(addPurchaseError);
        }

        setIsPurchaseModalOpen(false);
    };

    function comp_func(option, value) {
        return option.id == value.id;
    }

    const registration: Registration = purchasesList?.regs.find(item => item.id == registrationRow?.id);
    //console.log(params)
    //console.log(purchasesList)

    return (
        <Card sx={{ padding: "4px 16px 8px" }}>
            <MDBox ownerState={{
                variant: "contained",
                bgColor: "secondary",
                coloredShadow: "secondary",
            }}
                borderRadius={2}
                sx={{ display: 'flex', width: '100%' }} pb={1} px={2} mt={-1} >
                <MDTypography variant="h3" ownerState={{ color: "white" }}>
                    Purchases
                </MDTypography>
            </MDBox>

            <MDBox
                px={0} py={2} textAlign="right"
            >
                <MDButton
                    ownerState={{
                        size: "medium",
                        variant: "text",
                        color: "info",
                        textTransform: "uppercase",
                    }}
                    startIcon={<AddIcon />}
                    onClick={() => { setIsPurchaseModalOpen(true); purchaseReset({ number: 1 }); }}>
                    Register
                </MDButton>
            </MDBox>


            {isSmallScreen ? (
                <Grid container spacing={1}>
                    <Grid item xs={11}>
                        <Card>
                            {/*<DataGrid 
                                />*/
                            }
                        </Card>
                    </Grid></Grid>
            ) : (
                <MDBox component="table" sx={{ borderSpacing: "0px" }}>
                    <MDBox component="thead" ownerState={{
                        variant: "contained",
                        bgColor: "light"
                    }}
                        borderRadius={2}>
                        <MDBox component="tr" >
                            <MDBox component="td" textAlign="left" px={1} py={1}>
                                <MDTypography variant="h5"
                                    ownerState={{
                                        color: "dark",
                                        fontWeight: "bold"
                                    }} >
                                </MDTypography>
                            </MDBox>
                            <MDBox component="td" textAlign="left" px={1} py={1}>
                                <MDTypography variant="h5"
                                    ownerState={{
                                        color: "dark",
                                        fontWeight: "bold"
                                    }} >
                                    Product Name
                                </MDTypography>
                            </MDBox>
                            <MDBox component="td" textAlign="left" px={1}>
                                <MDTypography variant="h5"
                                    ownerState={{
                                        color: "dark",
                                        fontWeight: "bold"
                                    }} >
                                    Purchase Date
                                </MDTypography>
                            </MDBox>
                            <MDBox component="td" textAlign="left" px={1}>
                                <MDTypography variant="h5"
                                    ownerState={{
                                        color: "dark",
                                        fontWeight: "bold"
                                    }} >
                                    Class Name
                                </MDTypography>
                            </MDBox>
                            <MDBox component="td" textAlign="left" px={1}>
                                <MDTypography variant="h5"
                                    ownerState={{
                                        color: "dark",
                                        fontWeight: "bold"
                                    }} >
                                    Available
                                </MDTypography>
                            </MDBox>
                            <MDBox component="td" textAlign="left" px={1}>
                                <MDTypography variant="h5"
                                    ownerState={{
                                        color: "dark",
                                        fontWeight: "bold"
                                    }} >
                                    Signed Up
                                </MDTypography>
                            </MDBox>

                            <MDBox component="td" textAlign="center" px={1}>
                                <MDTypography variant="h5"
                                    ownerState={{
                                        color: "dark",
                                        fontWeight: "bold"
                                    }} >
                                    Add
                                </MDTypography>
                            </MDBox>
                            <MDBox component="td" textAlign="center" px={1}>
                                <MDTypography variant="h5"
                                    ownerState={{
                                        color: "dark",
                                        fontWeight: "bold"
                                    }} >
                                    Delete
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                    </MDBox>
                    <MDBox component="tbody" style={{ border: "2px" }}>
                        {purchasesList?.regs.map((row) => (
                            <PurchaseRow
                                key={row.id}
                                row={row}
                                handleRegistrationDeleteClick={handleRegistrationDeleteClick}
                                handleAddSignUpClick={handleAddSignUpClick}
                                handleSignUpDeleteClick={handleSignUpDeleteClick}
                                handleEditRegistrationsClick={handleEditRegistrationsClick}
                            />
                        ))}
                    </MDBox>
                </MDBox>
            )}

            {/* ================== Add registration and purchase dialog =================== */}
            <Dialog
                open={isPurchaseModalOpen}
                maxWidth="md"
                fullWidth={true}
                onClose={() => setIsPurchaseModalOpen(false)}>
                <MDTypography variant="h5" px={1} py={1}>
                    Adding Purchase
                    <CloseIcon onClick={() => setIsPurchaseModalOpen(false)}
                        sx={{ position: "absolute", top: "10px", right: "10px" }} />
                </MDTypography>
                <DialogContent dividers>
                    <form onSubmit={purchaseHandleSubmit(onPurchaseFormSubmit)}>
                        <MDBox px={1}
                            display="flex"
                            flexDirection="row"
                            justifyContent="flex-start"
                            alignItems="center">
                            <MDTypography variant="h4" px={1} ownerState={{ color: "dark" }}>Number</MDTypography>
                            <MDInput
                                {...purchaseRegister('number', { required: true, valueAsNumber: true })}
                                aria-invalid={purchaseErrors.number ? true : false}
                                type='number'
                                variant="standard"
                                size="medium"
                            />
                            {purchaseErrors.number && <MDBox><MDTypography variant="h6" px={1} ownerState={{ color: "error" }}>This field is required</MDTypography></MDBox>}
                        </MDBox>
                        <Controller
                            render={({ field: { onChange } }) => (
                                <Autocomplete
                                    options={products}
                                    groupBy={(option) => option.group}
                                    sx={{ color: "dark" }}
                                    renderGroup={(params) => (
                                        <>
                                            {/*{console.log(params,"params")}*/}
                                            <MDBox component="li" key={params.key} ownerState={{ color: "dark" }}>
                                                <GroupHeader>{params.group}</GroupHeader>
                                                <GroupItems sx={{ color: "dark" }}> <span style={{ color: "dark" }}>{params.children}</span></GroupItems>
                                            </MDBox></>
                                    )}
                                    renderInput={params => (
                                        <MDInput
                                            {...params}
                                            label="Choose a product"
                                            variant="outlined"
                                            color="info"

                                        />
                                    )}
                                    onChange={(e, data) => onChange(data)}

                                />
                            )}
                            defaultValue={null}
                            name="product"
                            rules={{
                                required: 'required selection',
                            }}
                            control={purchaseControl}
                        />
                        {purchaseErrors.product && <MDBox><MDTypography variant="h6" px={1} ownerState={{ color: "error" }}>This field is required</MDTypography></MDBox>}
                        <MDBox
                            display="flex"
                            justifyContent="center"
                            alignItems="baseline"
                            flexDirection="row"
                            gap="16px"
                            pt={2}
                            pb={0.5}
                            px={2}
                            width="100%"
                        >
                            <MDButton
                                ownerState={{
                                    variant: "gradient",
                                    color: "info",
                                    textTransform: "none",
                                    circular: false,
                                    iconOnly: false,
                                    darkMode: false
                                }}
                                size="medium"
                                type="submit">
                                Submit </MDButton>
                            <MDButton
                                size="medium"
                                onClick={() => setIsPurchaseModalOpen(false)}
                                ownerState={{
                                    textTransform: "none",
                                    variant: "gradient",
                                    color: "warning",
                                }}>
                                Cancel </MDButton>
                        </MDBox>
                    </form>
                </DialogContent>
            </Dialog>

            {/* ================== Confirm purchase deletion when dates are scheduled =================== */}
            <Dialog
                open={isConfirmRegistrationDeletionOpen != '0'}
                onClose={() => setIsConfirmRegistrationDeletionOpen('0')}>
                <MDTypography variant="h5" px={1} py={1}>
                    Confirm Purchase Deletion
                    <CloseIcon onClick={() => setIsConfirmRegistrationDeletionOpen('0')}
                        sx={{ position: "absolute", top: "10px", right: "10px" }} />
                </MDTypography>
                <DialogContent dividers>
                    <DialogContentText id="registration-delete-alert-content">
                        All dates for this purchase will be cancelled
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MDBox
                        display="flex"
                        justifyContent="center"
                        alignItems="baseline"
                        flexDirection="row"
                        gap="16px"
                        pt={2}
                        pb={0.5}
                        px={2}
                        width="100%"
                    >
                        <MDButton
                            size="medium"
                            onClick={() => setIsConfirmRegistrationDeletionOpen('0')}
                            autoFocus
                            ownerState={{
                                textTransform: "none",
                                variant: "gradient",
                                color: "warning",
                            }}>
                            Cancel </MDButton>
                        <MDButton
                            ownerState={{
                                variant: "gradient",
                                color: "dark",
                                textTransform: "none",
                                circular: false,
                                iconOnly: false,
                                darkMode: false
                            }}
                            onClick={handleRegistrationDeleteConfirmation}
                            aria-label="Delete"
                        >
                            Delete
                            <DeleteIcon />
                        </MDButton>
                    </MDBox>
                </DialogActions>
            </Dialog>


            {/* ================== Select and add event dialog =================== */}
            {isAddSignUpModalOpen && (
                <AddEventDialog
                    regId={registration?.id}
                    classId={registration?.classId}
                    studentId={registration?.purchase.studentId}
                    onSave={() => { refetch(); setIsAddSignUpModalOpen(false); }}
                    onClose={() => { setIsAddSignUpModalOpen(false); }} />
            )}

            {/* ================== Edit number of available registrations ==========================*/}
            {isEditRegistrationModalOpen && (
                <UpdateRegistrationCountDialog onClose={handleSaveRegCountValue} reg={registration} />
            )}
        </Card>
    )
}

export default Purchases;

function PurchaseRow(props: { row: Registration, handleRegistrationDeleteClick, handleAddSignUpClick, handleSignUpDeleteClick, handleEditRegistrationsClick }) {
    const { row, handleRegistrationDeleteClick, handleAddSignUpClick, handleSignUpDeleteClick, handleEditRegistrationsClick } = props;
    const [open, setOpen] = React.useState(false);
    return (
        <React.Fragment>
            <MDBox component="tr" sx={{ '& > *': { borderBottom: 'solid 1px rgba(0, 0, 0, 0.08);' }, '& > *:hover': { backgroundColor: "black" } }}>
                <MDBox component="td">
                    {row.signedNum > 0 &&
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setOpen(!open)}
                        >
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>}
                </MDBox>

                <MDBox textAlign="left" component="th" sx={{ '& > *:hover': { backgroundColor: "black" } }}>
                    <MDTypography variant="h5"
                        ownerState={{
                            color: "inherit",
                            fontWeight: "regular"
                        }}>
                        {row.prodName}
                    </MDTypography></MDBox>
                <MDBox component="td" textAlign="left" px={2}>
                    <MDTypography variant="h5"
                        ownerState={{
                            color: "inherit",
                            fontWeight: "regular"
                        }}>
                        {row.date}
                    </MDTypography></MDBox>
                <MDBox component="td" textAlign="left">
                    <MDTypography variant="h5"
                        ownerState={{
                            color: "inherit",
                            fontWeight: "regular"
                        }}>
                        {row.class}
                    </MDTypography></MDBox>
                <MDBox component="td" textAlign="center">
                    {/*<MDTypography variant="h5" onClick={() => {handleEditRegistrationsClick(row)}}
                        ownerState={{
                            color: "inherit",
                            fontWeight: "regular"
                        }}>
                        {row.availableNum}
                    </MDTypography>*/}
                    <MDButton
                        ownerState={{
                            size: "medium",
                            variant: "text",
                            color: "info",
                            textTransform: "uppercase",
                        }} onClick={() => { handleEditRegistrationsClick(row) }}>{row.availableNum}</MDButton>
                </MDBox>
                <MDBox component="td" textAlign="center">
                    <MDTypography variant="h5"
                        ownerState={{
                            color: "inherit",
                            fontWeight: "regular"
                        }}>
                        {row.signedNum}
                    </MDTypography></MDBox>
                <MDBox component="td">
                    {(row.availableNum > 0) &&
                        <IconButton aria-label="Sign Up" onClick={() => { handleAddSignUpClick(row); }}>
                            <EventAvailableIcon />
                        </IconButton>}
                </MDBox>
                <MDBox component="td">
                    <IconButton aria-label="Delete" onClick={() => { handleRegistrationDeleteClick(row); }}>
                        <DeleteIcon />
                    </IconButton>
                </MDBox>
            </MDBox>
            <MDBox component="tr" ownerState={{
                variant: "contained",
                bgColor: "light"
            }}>
                <MDBox component="td" ownerState={{
                    variant: "contained",
                    bgColor: "white"
                }} />
                <td colSpan={5} style={{ paddingBottom: 0, paddingTop: 0, textAlign: "center" }}>
                    <Collapse in={open} timeout="auto" unmountOnExit >
                        <MDBox sx={{ margin: 0 }} width="100%">
                            <MDTypography variant="h6" gutterBottom>
                                Scheduled Events
                            </MDTypography>
                            <MDBox component="table"
                                sx={{ borderSpacing: "0px", border: "solid 1px", width: "100%" }}>
                                <MDBox component="thead"
                                    borderRadius={2}>
                                    <MDBox component="tr">
                                        <MDBox component="td">
                                            <MDTypography variant="h5"
                                                ownerState={{
                                                    color: "dark",
                                                    fontWeight: "bold"
                                                }} >
                                                Date
                                            </MDTypography>
                                        </MDBox>
                                        <MDBox component="td">
                                            <MDTypography variant="h5"
                                                ownerState={{
                                                    color: "dark",
                                                    fontWeight: "bold"
                                                }} >
                                                Class Name
                                            </MDTypography>
                                        </MDBox>
                                        <MDBox component="td">
                                            <MDTypography variant="h5"
                                                ownerState={{
                                                    color: "dark",
                                                    fontWeight: "bold"
                                                }} >
                                                Status
                                            </MDTypography>
                                        </MDBox>
                                        <MDBox component="td">
                                            <MDTypography variant="h5"
                                                ownerState={{
                                                    color: "dark",
                                                    fontWeight: "bold"
                                                }} >
                                                Delete
                                            </MDTypography>
                                        </MDBox>
                                    </MDBox>
                                </MDBox>
                                <MDBox component="tbody">
                                    {row.signups.map((signup) => (
                                        <MDBox key={signup.id} component="tr">
                                            <MDBox component="td" textAlign="center">
                                                <MDTypography variant="h5"
                                                    ownerState={{
                                                        color: "inherit",
                                                        fontWeight: "medium"
                                                    }}>
                                                    {signup.eventDate}
                                                </MDTypography>
                                            </MDBox>
                                            <MDBox component="td" textAlign="center">
                                                <MDTypography variant="h5"
                                                    ownerState={{
                                                        color: "inherit",
                                                        fontWeight: "regular"
                                                    }}>
                                                    {signup.class}
                                                </MDTypography>
                                            </MDBox>
                                            <MDBox component="td" textAlign="center">
                                                <MDTypography variant="h5"
                                                    ownerState={{
                                                        color: "inherit",
                                                        fontWeight: "regular"
                                                    }}>
                                                    {getStatus(signup.status)}
                                                </MDTypography></MDBox>
                                            <MDBox component="td" textAlign="center">
                                                <MDTypography variant="h5"
                                                    ownerState={{
                                                        color: "inherit",
                                                        fontWeight: "regular"
                                                    }}>
                                                    <IconButton aria-label="Delete" onClick={() => {
                                                        handleSignUpDeleteClick(signup.id);
                                                        if (row.signedNum == 1) setOpen(false);
                                                    }}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </MDTypography></MDBox>
                                        </MDBox>
                                    ))}
                                </MDBox>
                            </MDBox>
                        </MDBox>
                    </Collapse>
                </td>
            </MDBox>
        </React.Fragment>
    );
}

interface UpdateRegistrationCountDialogProps {
    reg: any;
    onClose: (reg?: any, updated?: number) => void;
}

function UpdateRegistrationCountDialog(props: UpdateRegistrationCountDialogProps) {
    const { onClose, reg: reg } = props;
    const [value, setValue] = useState(reg.availableNum);

    const handleCancel = () => {
        onClose();
    };

    const handleOk = () => {
        onClose(reg, value);
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const num = Number((event.target as HTMLInputElement).value);
        if (Number.isNaN(num) || num < 0) return;
        setValue(num);
    };

    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
            maxWidth="xs"
            open={true}
        >
            <MDTypography variant="h5" px={1} py={1}>
                Adjust available number
                <CloseIcon onClick={handleCancel}
                    sx={{ position: "absolute", top: "10px", right: "10px" }} />
            </MDTypography>

            <DialogContent dividers>
                <TextField
                    id="count-number"
                    label="Count"
                    type="number"
                    value={value}
                    onChange={handleChange}
                />
            </DialogContent>
            <DialogActions>
                <MDBox
                    display="flex"
                    justifyContent="center"
                    alignItems="baseline"
                    flexDirection="row"
                    gap="16px"
                    width="100%"
                >
                    <MDButton
                        size="medium"
                        onClick={handleCancel}
                        autoFocus
                        ownerState={{
                            textTransform: "none",
                            variant: "gradient",
                            color: "warning",
                        }}>
                        Cancel </MDButton>
                    <MDButton onClick={handleOk}
                        ownerState={{
                            variant: "gradient",
                            color: "info",
                            textTransform: "none",
                            circular: false,
                            iconOnly: false,
                            darkMode: false
                        }}
                        size="medium">Save</MDButton>
                </MDBox>
            </DialogActions>
        </Dialog>
    );
}


